import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d36e88de"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "dashboard-view container py-4 py-sm-5"
}
const _hoisted_2 = { class: "d-flex flex-wrap col-12 align-items-center" }
const _hoisted_3 = { class: "line-title" }
const _hoisted_4 = { class: "d-flex align-items-center col" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line-visual" }, null, -1))
const _hoisted_6 = { class: "menu-items py-4 py-sm-5" }
const _hoisted_7 = { class: "list-unstyled m-0 d-flex flex-wrap row" }
const _hoisted_8 = { class: "col-12 col-sm-6 ps-0" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/img/icons/profile_icon.svg",
  class: "mb-3",
  alt: "Profile",
  width: "40",
  height: "40"
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "My Profile", -1))
const _hoisted_11 = { class: "col-12 col-sm-6 pe-0" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/img/icons/product_icon.svg",
  class: "mb-3",
  alt: "Media Receiver",
  width: "40",
  height: "40"
}, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "My Products", -1))
const _hoisted_14 = { class: "col-12 px-0" }

import { useHead } from "@unhead/vue";
import { useAuthStore } from "@/stores/auth";
import { onBeforeMount, Ref, ref } from "vue";
import { useUserStore } from "@/stores/user";
import BrandDashboard from "@/components/dashboard/BrandDashboard.vue";
import brand from "@/brand";


export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardView',
  setup(__props) {

useHead({
  title: "Dashboard",
});

const authStore = useAuthStore();
const userStore = useUserStore();

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_unref(brand).provider)
    ? (_openBlock(), _createBlock(BrandDashboard, { key: 0 }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createTextVNode("Hello" + _toDisplayString(_unref(userStore).name ? ',' : '') + " ", 1),
            _createElementVNode("div", _hoisted_4, [
              _createTextVNode(_toDisplayString(_unref(userStore).name || ""), 1),
              _hoisted_5
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("ul", _hoisted_7, [
            _createElementVNode("li", _hoisted_8, [
              _createVNode(_component_router_link, {
                to: { name: 'Profile'},
                class: "btn btn-light col-12 block flex-centered-col"
              }, {
                default: _withCtx(() => [
                  _hoisted_9,
                  _hoisted_10
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_11, [
              _createVNode(_component_router_link, {
                to: { name: 'Products'},
                class: "btn btn-light col-12 block flex-centered-col"
              }, {
                default: _withCtx(() => [
                  _hoisted_12,
                  _hoisted_13
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_14, [
              _createElementVNode("div", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(authStore).logout())),
                class: "btn btn-light col-12"
              }, "Logout")
            ])
          ])
        ])
      ]))
}
}

})